import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { motion } from 'framer-motion';
import { Mail, CheckCircle2, XCircle } from 'lucide-react';
import { API } from '../App';

const UnsubscribePage = () => {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('Processing your request…');

  useEffect(() => {
    const run = async () => {
      if (!token) {
        setStatus('error');
        setMessage('No unsubscribe token provided.');
        return;
      }
      try {
        const res = await axios.get(`${API}/unsubscribe`, { params: { token } });
        if (res.data?.success) {
          setStatus('success');
          setMessage(res.data.message || 'You have been unsubscribed.');
        } else {
          setStatus('error');
          setMessage(res.data?.message || 'Unsubscribe failed.');
        }
      } catch (e) {
        setStatus('error');
        setMessage(e.response?.data?.detail || 'Unsubscribe failed. Please try again.');
      }
    };
    run();
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center py-16 bg-accent" data-testid="unsubscribe-page">
      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        animate={{ opacity: 1, scale: 1 }}
        className="max-w-lg w-full mx-auto px-6"
      >
        <div className="bg-white border border-border p-10 text-center">
          <div className="flex justify-center mb-5">
            {status === 'loading' && <Mail size={56} className="text-primary animate-pulse" />}
            {status === 'success' && <CheckCircle2 size={56} className="text-green-600" />}
            {status === 'error' && <XCircle size={56} className="text-red-600" />}
          </div>
          <h1 className="text-3xl font-heading font-bold mb-3" data-testid="unsubscribe-title">
            {status === 'success' && 'Unsubscribed'}
            {status === 'error' && 'Unable to Unsubscribe'}
            {status === 'loading' && 'Please wait…'}
          </h1>
          <p className="text-muted-foreground mb-8" data-testid="unsubscribe-message">{message}</p>
          {status === 'success' && (
            <p className="text-sm text-muted-foreground mb-6">
              You will no longer receive our weekly collections mailer. You'll still receive transactional emails (orders, payments, account approvals).
            </p>
          )}
          <Link
            to="/"
            className="inline-block bg-primary text-primary-foreground hover:bg-primary/90 px-6 py-3 font-medium transition-colors"
            data-testid="unsubscribe-home-btn"
          >
            Back to Ambika Fashion
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default UnsubscribePage;
